export const CSRF_RELOAD_TIMEOUT = 3000;
export const DESKTOP_WIDTH = 1024;
export const CART_ICON_ANIMATION_DURATION = 500;
export const OPEN_CART_FOR_DESKTOP_BUFFER = 100;
export const AUTO_CLOSE_CART_FOR_DESKTOP_DELAY = 2000;
export const OPEN_CART_FOR_DESKTOP_DELAY =
  CART_ICON_ANIMATION_DURATION + OPEN_CART_FOR_DESKTOP_BUFFER;

// Segment Analytics Events
export const AUTO_SHIP_ENABLED = 'Auto-Ship Enabled';
export const AUTO_SHIP_DISABLED = 'Auto-Ship Disabled';
export const PRODUCT_ADDED = 'Product Added';
export const PRODUCT_REMOVED = 'Product Removed';
export const CART_UPSELL_BANNER = 'Cart Upsell Banner';
export const QUICK_SHOP_INTERACTION = 'Quick Shop Interaction';
export const OPEN_QUICK_SHOP_MODAL = 'Open Quick Shop Modal';
export const CLOSE_QUICK_SHOP_MODAL = 'Close Quick Shop Modal';
export const NICOTINE_STRENGTH = 'Nicotine Strength';
export const POD_PACK_SIZE = 'Pod Pack Size';
